/**
 * 基礎資料後台（20260611 反饋批次）6 頁共用的 label 與樣式常數。
 * label 盡量取自 shared 常數的 Loc，避免各頁重複手刻。
 */
import { Badge } from "../../components/ui/badge";
import { useLanguage } from "../../contexts/LanguageContext";
import { AIRPORTS, type Loc } from "../../../../shared/const";
import { ZONES } from "../../../../shared/booking";

export const asLoc = (s: string): Loc => ({ "zh-TW": s, "en-US": s, "zh-CN": s });

export const REGION_LOC: Record<"taiwan" | "hongkong", Loc> = {
  taiwan: { "zh-TW": "台灣", "en-US": "Taiwan", "zh-CN": "台湾" },
  hongkong: { "zh-TW": "香港", "en-US": "Hong Kong", "zh-CN": "香港" },
};

export const SHARED_REGION_LOC: Loc = { "zh-TW": "共用", "en-US": "Shared", "zh-CN": "共用" };

/** region 顯示（null = 兩區共用） */
export const regionLoc = (r: "taiwan" | "hongkong" | null | undefined): Loc =>
  r ? REGION_LOC[r] : SHARED_REGION_LOC;

export const zoneLoc = (code: string): Loc => ZONES.find((z) => z.code === code)?.label ?? asLoc(code);

export const airportLoc = (code: string): Loc => AIRPORTS.find((a) => a.code === code)?.name ?? asLoc(code);

/** 表頭列樣式（照 PricingRules 版型，但字級守 ≥12px 下限） */
export const THEAD_ROW =
  "border-b border-border text-left font-mono text-xs uppercase tracking-wider text-muted-foreground";

export function ActiveBadge({ active }: { active: "yes" | "no" }) {
  const { t } = useLanguage();
  return active === "yes" ? (
    <Badge variant="success">{t({ "zh-TW": "啟用中", "en-US": "Active", "zh-CN": "启用中" })}</Badge>
  ) : (
    <Badge variant="outline">{t({ "zh-TW": "已停用", "en-US": "Inactive", "zh-CN": "已停用" })}</Badge>
  );
}
